// Generated by ReScript, PLEASE EDIT WITH CARE

import * as IncentiveEntityMapper from "../entity-mapper/IncentiveEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as CampaignOrderEntityMapper from "../entity-mapper/CampaignOrderEntityMapper.bs.js";

var execute = IncentiveEntityMapper.execute;

var IncentivesResponseConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var IncentivesResponseConverter = partial_arg(IncentivesResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = CampaignOrderEntityMapper.execute;

var CampaignOrdersResponseConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var CampaignOrdersResponseConverter = partial_arg$1(CampaignOrdersResponseConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  IncentivesResponseConfig ,
  IncentivesResponseConverter ,
  CampaignOrdersResponseConfig ,
  CampaignOrdersResponseConverter ,
  
}
/* IncentivesResponseConverter Not a pure module */
